type Props = {
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
    id?: string | number;
};

export function BankIcon({ width = 12, height = 12, className, style }: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            className={className}
            style={style}
        >
            <path
                d="M1.35289 3.1831L5.5 0.788761C5.8094 0.610126 6.1906 0.610126 6.5 0.788761L10.6471 3.1831C10.8655 3.30918 11 3.54217 11 3.79432C11 4.1841 10.684 4.50009 10.2942 4.50009H1.70577C1.31599 4.50009 1 4.1841 1 3.79432C1 3.54217 1.13452 3.30917 1.35289 3.1831Z"
                fill="currentColor"
            />
            <path
                d="M6 5.50012C6.3452 5.50012 6.625 5.77992 6.625 6.12512V8.25012C6.625 8.59527 6.3452 8.87512 6 8.87512C5.6548 8.87512 5.375 8.59527 5.375 8.25012V6.12512C5.375 5.77992 5.6548 5.50012 6 5.50012Z"
                fill="currentColor"
            />
            <path
                d="M10.375 11.0001C10.7202 11.0001 11 10.7203 11 10.3751C11 10.0299 10.7202 9.75012 10.375 9.75012H1.625C1.27982 9.75012 1 10.0299 1 10.3751C1 10.7203 1.27982 11.0001 1.625 11.0001H10.375Z"
                fill="currentColor"
            />
            <path
                d="M8.75 5.50012C9.0952 5.50012 9.375 5.77992 9.375 6.12512V8.25012C9.375 8.59527 9.0952 8.87512 8.75 8.87512C8.4048 8.87512 8.125 8.59527 8.125 8.25012V6.12512C8.125 5.77992 8.4048 5.50012 8.75 5.50012Z"
                fill="currentColor"
            />
            <path
                d="M3.25 5.50012C3.59518 5.50012 3.875 5.77992 3.875 6.12512V8.25012C3.875 8.59527 3.59518 8.87512 3.25 8.87512C2.90482 8.87512 2.625 8.59527 2.625 8.25012V6.12512C2.625 5.77992 2.90482 5.50012 3.25 5.50012Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default BankIcon;
